const getEmbedCode = ({ checkoutUrl, overlayUrl }) => {
  return `<div class="cp-checkout" data-checkout="${checkoutUrl}" style="width: 100%;"></div>
<script type="text/javascript" src="${overlayUrl}" async></script>`;
};

export default getEmbedCode;
